import * as React from "react"

import { cn } from "@/lib/utils"

const focusClasses = "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
const disabledClasses = "disabled:cursor-not-allowed disabled:opacity-50"
const errorClasses = "data-[show-error]:aria-[invalid=true]:border-destructive data-[show-error]:aria-[invalid=true]:ring-destructive"
/*
TODO: Later we will probably want readonly to look more like regular text. But we would need to add readOnly to Select, VirtualizedSelect, and DatePicker

Change to this:
const readonlyClasses = "read-only:border-transparent read-only:bg-transparent read-only:px-0 read-only:cursor-text read-only:focus-visible:ring-0 read-only:focus-visible:ring-offset-0 read-only:text-slate-600"
*/
const readonlyClasses = "read-only:border-muted read-only:cursor-default read-only:focus-visible:ring-0 read-only:focus-visible:ring-offset-0 read-only:opacity-50"

const Input = React.memo(
  React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(({ className, type, placeholder, readOnly, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground md:text-sm",
          focusClasses,
          disabledClasses,
          readonlyClasses,
          errorClasses,
          className,
        )}
        placeholder={readOnly ? undefined : placeholder}
        readOnly={readOnly}
        ref={ref}
        {...props}
      />
    )
  }),
)
Input.displayName = "Input"

export { Input }
